import React from "react";
import PropTypes from "prop-types";
import { Paragraph, Text } from "components/core/Typography";
import { Link } from "components/core/Link";
import { CircleArrow } from "components/core/Icons";

import "./NearbyCard.scss";

const NearbyCard = ({ city }) => {
	const formattedCity = `${city.city}, ${city.state}`;
	const showDistance = typeof city.distance === "number" && city.distance > 0;
	const distanceText =
		city.distance === 1
			? `${city.distance} mile away`
			: `${city.distance} miles away`;
	return (
		<Link
			href={`/${city.uri}`}
			weight="semiBold"
			className="nearby-card"
		>
			<div>
				<Text
					weight="semiBold"
					color="blue"
				>
					{formattedCity}
				</Text>
				{showDistance && (
					<Paragraph
						size="small"
						color="gray"
						weight="standard"
						last
					>
						{distanceText}
					</Paragraph>
				)}
			</div>
			<div className="nearby-button">
				<CircleArrow size="xlarge" />
			</div>
		</Link>
	);
};

NearbyCard.propTypes = {
	city: PropTypes.object
};

export default NearbyCard;
